import { render, staticRenderFns } from "./parentsInformation.vue?vue&type=template&id=0d523473&scoped=true&"
import script from "./parentsInformation.vue?vue&type=script&lang=js&"
export * from "./parentsInformation.vue?vue&type=script&lang=js&"
import style0 from "./parentsInformation.vue?vue&type=style&index=0&id=0d523473&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d523473",
  null
  
)

export default component.exports